// TODO: define all attribute/property formats here

// OOTB formats can be found in csi/types in this object:
// formatsByType: {
// 	"double": [ /* list of formats */ ],
// 	"integer": [ /* list of formats */ ],
// 	"string": [ /* list of formats */ ],
// 	"time": [ /* list of formats */ ],
// 	"stringmap": [ /* list of formats */ ],
// },

export const FORMAT_TYPE = "Type";

// Empty format
export const FORMAT_EMPTY = "";

// C8NodeType: double
export const FORMAT_INTEGER = "0";

// Decimal formats with optional decimal places
export const FORMAT_DECIMAL_OPTIONAL_1 = "0.#";
export const FORMAT_DECIMAL_OPTIONAL_2 = "0.##";
export const FORMAT_DECIMAL_OPTIONAL_3 = "0.###";
export const FORMAT_DECIMAL_OPTIONAL_4 = "0.####";

// Decimal formats with fixed decimal places
export const FORMAT_DECIMAL_FIXED_1 = "0.0";
export const FORMAT_DECIMAL_FIXED_2 = "0.00";
export const FORMAT_DECIMAL_FIXED_3 = "0.000";
export const FORMAT_DECIMAL_FIXED_4 = "0.0000";

// Grouped integer format
export const FORMAT_GROUPED_INTEGER = "#,##0";

// Grouped decimal formats with optional decimal places
export const FORMAT_GROUPED_DECIMAL_OPTIONAL_1 = "#,##0.#";
export const FORMAT_GROUPED_DECIMAL_OPTIONAL_2 = "#,##0.##";
export const FORMAT_GROUPED_DECIMAL_OPTIONAL_3 = "#,##0.###";
export const FORMAT_GROUPED_DECIMAL_OPTIONAL_4 = "#,##0.####";

// Grouped decimal formats with fixed decimal places
export const FORMAT_GROUPED_DECIMAL_FIXED_1 = "#,##0.0";
export const FORMAT_GROUPED_DECIMAL_FIXED_2 = "#,##0.00";
export const FORMAT_GROUPED_DECIMAL_FIXED_3 = "#,##0.000";
export const FORMAT_GROUPED_DECIMAL_FIXED_4 = "#,##0.0000";

// Currency formats
export const FORMAT_CURRENCY_INTEGER = "$#,##0";
export const FORMAT_CURRENCY_DECIMAL_FIXED_1 = "$#,##0.0";
export const FORMAT_CURRENCY_DECIMAL_FIXED_2 = "$#,##0.00";
export const FORMAT_CURRENCY_DECIMAL_FIXED_3 = "$#,##0.000";
export const FORMAT_CURRENCY_DECIMAL_FIXED_4 = "$#,##0.0000";

// Percentage formats with fixed decimal places
export const FORMAT_PERCENTAGE_INTEGER = "0%";
export const FORMAT_PERCENTAGE_DECIMAL_FIXED_1 = "0.0%";
export const FORMAT_PERCENTAGE_DECIMAL_FIXED_2 = "0.00%";
export const FORMAT_PERCENTAGE_DECIMAL_FIXED_3 = "0.000%";
export const FORMAT_PERCENTAGE_DECIMAL_FIXED_4 = "0.0000%";

// Percentage formats with optional decimal places
export const FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_1 = "0.#%";
export const FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_2 = "0.##%";
export const FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_3 = "0.###%";
export const FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_4 = "0.####%";

// C8NodeType: integer
// Reusing constants from double type where applicable

// C8NodeType: ref
export const FORMAT_IMAGE = "Image";
export const FORMAT_TAG = "Tag";

// only for rendering image of referenced nodes, not attribute format
export const FORMAT_REFERENCED_IMAGE = "ReferencedImage";

// C8NodeType: string
export const FORMAT_ALPHANUMERIC = "Alphanumeric";
export const FORMAT_BARCODE = "Barcode";
export const FORMAT_COMMENT = "Comment";
export const FORMAT_COMMENT_LATEST = "CommentLatest";
export const FORMAT_EMAIL = "Email";
export const FORMAT_PHONE = "Phone";
export const FORMAT_RICH = "Rich";
export const FORMAT_TEXTAREA = "Textarea";
export const FORMAT_URL = "URL";

// TODO: Selection is a string format, but only for OOTB attributes for now;
// that could change once we support aggregate stores for them
export const FORMAT_SELECTION = "Selection";

// C8NodeType: time
export const FORMAT_DATE = "Date";
export const FORMAT_TIME = "Time";
export const FORMAT_DATETIME = "DateTime";
export const FORMAT_DATETIME_SECONDS = "DateTimeSeconds";
export const FORMAT_DATETIME_ZONE = "DateTimeZone";
export const FORMAT_DIFF = "Diff";
export const FORMAT_UNIVERSAL_DATE = "UniversalDate";
export const FORMAT_UNIVERSAL_DATETIME = "UniversalDateTime";
export const FORMAT_UNIVERSAL_TIME = "UniversalTime";

// C8NodeType: stringmap
export const FORMAT_LOCALIZED = "Localized";
export const FORMAT_LOCALIZED_TEXTAREA = "LocalizedTextarea";
export const FORMAT_LOCALIZED_RICH = "LocalizedRich";

// C8NodeType: stringvector
// No formats needed as per the initial comment

// Misc TODO: categorize?
export const FORMAT_DATE_SHORT = "dateFormat-short";
export const FORMAT_TIME_MEDIUM = "timeFormat-medium";
export const FORMAT_TIME_SHORT = "timeFormat-short";
export const FORMAT_SAME_DAY = "dateFormatItem-d";
export const FORMAT_SAME_YEAR = "dateFormatItem-MMMd";
export const FORMAT_DIFF_YEAR = "dateFormat-medium";
export const FORMAT_MONTH = "dateFormatItem-MMM";

// Collecting all formats into the FORMAT object
export const FORMAT = {
	// Empty format
	EMPTY: FORMAT_EMPTY,

	// C8NodeType: double
	INTEGER: FORMAT_INTEGER,
	DECIMAL_OPTIONAL_1: FORMAT_DECIMAL_OPTIONAL_1,
	DECIMAL_OPTIONAL_2: FORMAT_DECIMAL_OPTIONAL_2,
	DECIMAL_OPTIONAL_3: FORMAT_DECIMAL_OPTIONAL_3,
	DECIMAL_OPTIONAL_4: FORMAT_DECIMAL_OPTIONAL_4,
	DECIMAL_FIXED_1: FORMAT_DECIMAL_FIXED_1,
	DECIMAL_FIXED_2: FORMAT_DECIMAL_FIXED_2,
	DECIMAL_FIXED_3: FORMAT_DECIMAL_FIXED_3,
	DECIMAL_FIXED_4: FORMAT_DECIMAL_FIXED_4,
	GROUPED_INTEGER: FORMAT_GROUPED_INTEGER,
	GROUPED_DECIMAL_OPTIONAL_1: FORMAT_GROUPED_DECIMAL_OPTIONAL_1,
	GROUPED_DECIMAL_OPTIONAL_2: FORMAT_GROUPED_DECIMAL_OPTIONAL_2,
	GROUPED_DECIMAL_OPTIONAL_3: FORMAT_GROUPED_DECIMAL_OPTIONAL_3,
	GROUPED_DECIMAL_OPTIONAL_4: FORMAT_GROUPED_DECIMAL_OPTIONAL_4,
	GROUPED_DECIMAL_FIXED_1: FORMAT_GROUPED_DECIMAL_FIXED_1,
	GROUPED_DECIMAL_FIXED_2: FORMAT_GROUPED_DECIMAL_FIXED_2,
	GROUPED_DECIMAL_FIXED_3: FORMAT_GROUPED_DECIMAL_FIXED_3,
	GROUPED_DECIMAL_FIXED_4: FORMAT_GROUPED_DECIMAL_FIXED_4,
	CURRENCY_INTEGER: FORMAT_CURRENCY_INTEGER,
	CURRENCY_DECIMAL_FIXED_1: FORMAT_CURRENCY_DECIMAL_FIXED_1,
	CURRENCY_DECIMAL_FIXED_2: FORMAT_CURRENCY_DECIMAL_FIXED_2,
	CURRENCY_DECIMAL_FIXED_3: FORMAT_CURRENCY_DECIMAL_FIXED_3,
	CURRENCY_DECIMAL_FIXED_4: FORMAT_CURRENCY_DECIMAL_FIXED_4,
	PERCENTAGE_INTEGER: FORMAT_PERCENTAGE_INTEGER,
	PERCENTAGE_DECIMAL_FIXED_1: FORMAT_PERCENTAGE_DECIMAL_FIXED_1,
	PERCENTAGE_DECIMAL_FIXED_2: FORMAT_PERCENTAGE_DECIMAL_FIXED_2,
	PERCENTAGE_DECIMAL_FIXED_3: FORMAT_PERCENTAGE_DECIMAL_FIXED_3,
	PERCENTAGE_DECIMAL_FIXED_4: FORMAT_PERCENTAGE_DECIMAL_FIXED_4,
	PERCENTAGE_DECIMAL_OPTIONAL_1: FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_1,
	PERCENTAGE_DECIMAL_OPTIONAL_2: FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_2,
	PERCENTAGE_DECIMAL_OPTIONAL_3: FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_3,
	PERCENTAGE_DECIMAL_OPTIONAL_4: FORMAT_PERCENTAGE_DECIMAL_OPTIONAL_4,

	// C8NodeType: string
	ALPHANUMERIC: FORMAT_ALPHANUMERIC,
	BARCODE: FORMAT_BARCODE,
	COMMENT: FORMAT_COMMENT,
	COMMENT_LATEST: FORMAT_COMMENT_LATEST,
	EMAIL: FORMAT_EMAIL,
	PHONE: FORMAT_PHONE,
	RICH: FORMAT_RICH,
	TEXTAREA: FORMAT_TEXTAREA,
	URL: FORMAT_URL,

	// C8NodeType: time
	DATE: FORMAT_DATE,
	TIME: FORMAT_TIME,
	DATETIME: FORMAT_DATETIME,
	DATETIME_SECONDS: FORMAT_DATETIME_SECONDS,
	DATETIME_ZONE: FORMAT_DATETIME_ZONE,
	DIFF: FORMAT_DIFF,
	UNIVERSAL_DATE: FORMAT_UNIVERSAL_DATE,
	UNIVERSAL_TIME: FORMAT_UNIVERSAL_TIME,

	// C8NodeType: stringmap
	LOCALIZED: FORMAT_LOCALIZED,
	LOCALIZED_TEXTAREA: FORMAT_LOCALIZED_TEXTAREA,
	LOCALIZED_RICH: FORMAT_LOCALIZED_RICH,
};

// Defining the attribute format type
export type C8AttributeFormat = typeof FORMAT[keyof typeof FORMAT];
